import { createContext, useContext, type ReactNode } from 'react';

export type SuggestionConfig = {
  title: string;
  label: string;
  prompt: string;
};

const SuggestionsContext = createContext<SuggestionConfig[]>([]);

export function SuggestionsProvider({
  suggestions,
  children,
}: {
  suggestions: SuggestionConfig[];
  children: ReactNode;
}) {
  return <SuggestionsContext.Provider value={suggestions}>{children}</SuggestionsContext.Provider>;
}

export function useSuggestions() {
  return useContext(SuggestionsContext);
}
